 
import { React, useEffect, useState, useRef, useMemo } from "react";
import {  getList,postList,genericPost } from "../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS } from "../../Constants";
import cogoToast from "cogo-toast";
import { Modal } from "react-bootstrap";
import { FaSpinner, FaTimes } from "react-icons/fa";

const WorkflowLevels = () => {
  const [workflows, setworkflows] = useState([])
  const [workflow_levels, setworkflow_levels] = useState([])
  const [users, setUsers] = useState([])
  const [projects, setProjects] = useState([])

  const [selectedWorkflow, setselectedWorkflow] = useState(null)
   

  const [show_create_level_modal, setshow_create_level_modal] = useState(false)
  const [show_update_level_modal, setshow_update_level_modal] = useState(false)
  const [show_create_level_assignment_modal, setshow_create_level_assignment_modal] = useState(false)

  
  const [workflow_assignments, setworkflow_assignments] = useState([])
  const [selectedWorkflowLevel, setselectedWorkflowLevel] = useState(null)
  const [IsLoading, setIsLoading] = useState(false)


  useEffect(() => {
  listWorkflows();
  listUsers();
  listProjects();
}, [])


const listWorkflowLevels=async (id)=>{
  setIsLoading(true);
  setworkflow_levels(await postList(ENDPOINTS.LIST_WORKFLOW_LEVELS,{
  "workflow_id": id
  }));
  setIsLoading(false);
} 

const listWorkflows =async ()=>{
  setIsLoading(true);
  setworkflows(await getList(ENDPOINTS.LIST_WORKFLOWS));
  setIsLoading(false);
} 

const listUsers =async ()=>{
  setIsLoading(true);
  setUsers( await getList(ENDPOINTS.LIST_USERS))
  setIsLoading(false);
} 
const listProjects =async ()=>{
  setIsLoading(true);
  setProjects( await getList(ENDPOINTS.LIST_PROJECTS))
  setIsLoading(false);
} 

const listLevelAssignments =async (id)=>{
  setIsLoading(true);
  setworkflow_assignments(
    await postList(ENDPOINTS.LIST_WORKFLOW_LEVEL_ASSIGNMENTS,{"workflow_level_id":id})
  )
  setIsLoading(false);
} 
const createWorkflowLevel=(e)=>{


  e?.preventDefault(); 
  let data={
      
      "workflow_id":selectedWorkflow?.id,
      "name":e.target.name.value,
      "level_no":e.target.level_no.value,
      "type":e.target.type.value,
      "user_type":e.target.user_type.value,
  }
  
  genericPost(ENDPOINTS.CREATE_WORKFLOW_LEVEL,data)
  .then((res) => {
    
    setIsLoading(false);
    if (res.status == 200) {
 
      let responseData = res.data;
      if (res.data.status == SUCCESS_RESULT) {
        
        cogoToast.success(responseData.message);
  setshow_create_level_modal(false);
  listWorkflowLevels(selectedWorkflow?.id);
        }
      else
      {
        cogoToast.error(responseData.message);
      }
      } else {
        cogoToast.error(res.data.message, {});
      }
    
  })
  .catch((err) => {
    setIsLoading(false);
    console.log(err);
  });

}
const createWorkflowLevelAssignment=(e)=>{


  e?.preventDefault(); 
  let data=[{    
      "workflow_level_id":e.target.workflow_level_id.value,
      "entity_id":e.target.entity_id.value,
      "user_type":e.target.user_type.value,
      "resource_id":e.target.resource_id.value,
  }]
  
  genericPost(ENDPOINTS.CREATE_WORKFLOW_LEVEL_ASSIGNMENT,data)
  .then((res) => {
    
    setIsLoading(false);
    if (res.status == 200) {
 
      let responseData = res.data;
      if (res.data.status == SUCCESS_RESULT) {
        
        cogoToast.success(responseData.message);
  setshow_create_level_assignment_modal(false);
  listLevelAssignments(selectedWorkflowLevel?.id);
        }
      else
      {
        cogoToast.error(responseData.message);
      }
      } else {
        cogoToast.error(res.data.message, {});
      }
    
  })
  .catch((err) => {
    setIsLoading(false);
    console.log(err);
  });

}
const updateWorkflowLevel=(e)=>{


  e?.preventDefault(); 
  let data={
      
    "workflow_level_id":e.target.workflow_level_id.value,
      "workflow_id":e.target.workflow_id.value,
      "name":e.target.name.value,
      "level_no":e.target.level_no.value,
      "type":e.target.type.value,
      "user_type":e.target.user_type.value,
  }
  
  genericPost(ENDPOINTS.UPDATE_WORKFLOW_LEVEL,data)
  .then((res) => {
    
    setIsLoading(false);
    if (res.status == 200) {
 
      let responseData = res.data;
      if (res.data.status == SUCCESS_RESULT) {
        
        cogoToast.success(responseData.message);
  setshow_update_level_modal(false);
  listWorkflowLevels(selectedWorkflow?.id);
        }
      else
      {
        cogoToast.error(responseData.message);
      }
      } else {
        cogoToast.error(res.data.message, {});
      }
    
  })
  .catch((err) => {
    setIsLoading(false);
    console.log(err);
  });

}
  return (
    <div className='card'>

    
    <div className='card-body'>
 
<div className="row">
  
  <div className="col-md-12">
  <h1>
  Select Workflow
  <select name="workflowId" className="form-control" onChange={(e)=>{
  if(e.target.value==""){
setselectedWorkflow(null);
setworkflow_levels([]);
  }else{

 
      setselectedWorkflow(workflows.filter((w)=>w.id=e.target.value)[0]);
      listWorkflowLevels(e.target.value);
    }
    }}>
    <option value={""}>Select Workflow</option>
    {workflows?.map((w)=> {
    
    return  <option value={w.id} 
     >
    
      {w.name} ({w.total_levels} levels)
      
      </option>
    })}
  </select>
 {selectedWorkflow && <>WorkFlow Levels ({selectedWorkflow?.name}) </> } 
</h1>
<button className="btn-sm btn-success"  disabled={selectedWorkflow==null}
onClick={
  
  ()=>setshow_create_level_modal(true)

}


>Create New Level</button>
<table className="info_table">
<thead>
 
    <th> Name</th>
    <th>level No.</th>
    <th> Type </th>
    <th>Actions</th>

 
</thead>
{workflow_levels?.map((l)=> {
return <tr>
  <td>{l.name}</td>
  <td>{l.level_no}</td>
  <td>{l.type}</td>

  <td><button className='btn-sm btn-primary' onClick={
    
    ()=>{
      setselectedWorkflowLevel(l);
      setTimeout(() => {
        setshow_update_level_modal(true);
      }, 100);
       }
    
    }>Edit</button> &nbsp;&nbsp;
  
 
  
  {/* <button className='btn-sm btn-default' onClick={()=>{
      setselectedWorkflowLevel(l);
    listLevelAssignments(l.id);
    }}>View Assignments</button> */}
  </td>



</tr>
})}
</table>
  </div>

  {/* <div className="col-md-6">
  Workflow assignments
  <button onClick={()=>setshow_create_level_assignment_modal(true)} disabled={selectedWorkflowLevel==null}> Create Assignment </button>
  <table className="info_table">
<thead>
 
    <th> Entity (User)</th>
    <th>Resource (Project)</th>
    <th>Details </th>

  
    <th>Actions</th>

 
</thead>
{workflow_assignments.map((a)=> {
return <tr>
  <td>{users.filter((u)=> u.value==a.entity_id)[0]?.text}</td>
 
  <td>{projects.filter((p)=> p.id==a.resource_id)[0]?.project_name}</td>

  <td>{a.details}</td>

  <td><button className='btn-sm btn-primary' onClick={
    
    ()=>{
      // setselectedWorkflowLevel(l);
      // setTimeout(() => {
      //   setshow_update_level_modal(true);
      // }, 100);
       }
    
    }>Edit</button> &nbsp;&nbsp;
  
 
  
  <button className='btn-sm btn-default'>View Assignments</button>
  </td>



</tr>
})}
</table>
  </div> */}


</div>






{show_create_level_modal && (
          <div>
            <Modal show={show_create_level_modal} onHide={() => null}>
              <div className="modal-status bg-primary modal-big"></div>

              <Modal.Header style={{ backGroundColor: "red", width: "100%" }}>
                <h3 style={{ width: "100%", marginTop: "3%" }}>
                  <div className="row">
                    <div className="col-md-6">
                      <Modal.Title>Create New Level</Modal.Title>
                    </div>
                    <div className="col-md-6">
                      <FaTimes
                        onClick={() => {
                          setshow_create_level_modal(false);
                        }}
                        style={{
                          color: "red",
                          cursor: "pointer",
                          float: "right",
                        }}
                      />
                    </div>
                  </div>
                </h3>
              </Modal.Header>
              <Modal.Body>
<form onSubmit={createWorkflowLevel}>
  Name
  <input type="text" name="name" required className="form-control"></input>
  Level No.
  <input type="text" name="level_no" required className="form-control"></input>
  Type 
  <input type="text" name="type" required className="form-control"></input>

  User Type 
  <input type="text" name="user_type" required className="form-control"></input>

<br/>
{IsLoading? <> <FaSpinner></FaSpinner> </>: <input type="submit" className="btn btn-primary" value={"Create workflow Level"}/> }
</form>

              </Modal.Body>
            </Modal>
          </div>
        )}


{show_update_level_modal && (
          <div>
            <Modal show={show_update_level_modal} onHide={() => null}>
              <div className="modal-status bg-primary modal-big"></div>

              <Modal.Header style={{ backGroundColor: "red", width: "100%" }}>
                <h3 style={{ width: "100%", marginTop: "3%" }}>
                  <div className="row">
                    <div className="col-md-6">
                      <Modal.Title>Update Workflow level</Modal.Title>
                    </div>
                    <div className="col-md-6">
                      <FaTimes
                        onClick={() => {
                          setshow_update_level_modal(false);
                        }}
                        style={{
                          color: "red",
                          cursor: "pointer",
                          float: "right",
                        }}
                      />
                    </div>
                  </div>
                </h3>
              </Modal.Header>
              <Modal.Body>
<form onSubmit={updateWorkflowLevel}>
  <input type="hidden" name="workflow_level_id" value={selectedWorkflowLevel?.id}/> 
  <input type="hidden" name="workflow_id" value={selectedWorkflowLevel?.workflow_id} /> 
  Name
  <input type="text" name="name"  value={selectedWorkflowLevel?.name} onChange={(e)=>{setselectedWorkflowLevel({...selectedWorkflowLevel,name:e.target.value})}} required className="form-control"></input>
  Level No.
  <input type="text" name="level_no" value={selectedWorkflowLevel?.level_no} onChange={(e)=>{setselectedWorkflowLevel({...selectedWorkflowLevel,level_no:e.target.value})}} required className="form-control"></input>
  Type 
  <input type="text" name="type" required value={selectedWorkflowLevel?.type}  onChange={(e)=>{setselectedWorkflowLevel({...selectedWorkflowLevel,type:e.target.value})}} className="form-control"></input>
  User Type 
  <input type="text" name="user_type"  value={selectedWorkflowLevel?.user_type}  onChange={(e)=>{setselectedWorkflowLevel({...selectedWorkflowLevel,user_type:e.target.value})}} required className="form-control"></input>

<br/>
{IsLoading? <> <FaSpinner></FaSpinner> </>: <input type="submit" className="btn btn-primary" value={"Update workflow Level"}/> }
</form>

              </Modal.Body>
            </Modal>
          </div>
        )}



{show_create_level_assignment_modal && (
          <div>
            <Modal show={show_create_level_assignment_modal} onHide={() => null}>
              <div className="modal-status bg-primary modal-big"></div>

              <Modal.Header style={{ backGroundColor: "red", width: "100%" }}>
                <h3 style={{ width: "100%", marginTop: "3%" }}>
                  <div className="row">
                    <div className="col-md-9">
                      <Modal.Title>Create Assignment for {selectedWorkflowLevel.name}</Modal.Title>
                    </div>
                    <div className="col-md-3">
                      <FaTimes
                        onClick={() => {
                          setshow_create_level_assignment_modal(false);
                        }}
                        style={{
                          color: "red",
                          cursor: "pointer",
                          float: "right",
                        }}
                      />
                    </div>
                  </div>
                </h3>
              </Modal.Header>
              <Modal.Body>
<form onSubmit={createWorkflowLevelAssignment}>
  <input type="hidden" name="workflow_level_id" value={selectedWorkflowLevel.id}/>
  Resource
  <select name="resource_id" className="form-control">
    <option value={""}>Select Resource</option>
    {projects?.map((p)=>{  
    return  <option value={p.id}>{p.project_name}</option>
    })}
  </select>


  Entity

  <select name="entity_id" className="form-control">
    <option value={""}>Select Resource</option>
    {users?.map((u)=>{  
    return  <option value={u.value}>{u.text}</option>
    })}
  </select>
  <select name="user_type" className="form-control">
    <option value={1}>User Type 1</option>
    <option value={2}>User Type 2</option>
   
  </select>
 

<br/>
{IsLoading? <> <FaSpinner></FaSpinner> </>: <input type="submit" className="btn btn-primary" value={"Create workflow Level Assignment"}/> }
</form>

              </Modal.Body>
            </Modal>
          </div>
        )}


    </div>
    </div>
  )
}

export default WorkflowLevels